var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMailIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.8024 6.59091C21.8024 5.50758 20.9161 4.62122 19.8327 4.62122H4.07517C2.99183 4.62122 2.10547 5.50758 2.10547 6.59091M21.8024 6.59091V18.4091C21.8024 19.4924 20.9161 20.3788 19.8327 20.3788H4.07517C2.99183 20.3788 2.10547 19.4924 2.10547 18.4091V6.59091M21.8024 6.59091L11.954 13.4849L2.10547 6.59091",
    stroke: "#202020",
    strokeWidth: 1.18182,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMailIcon);
export default __webpack_public_path__ + "static/media/Mail_icon.c36426b0ac67a87bcc2105a459467546.svg";
export { ForwardRef as ReactComponent };